import React, { useState } from 'react';
import { FormGroup } from 'react-bootstrap';

export function Radio({
  label,
  options,
  requiredField,
  error,
  fromForm,
  duplicatingItem,
  index,
  i,
  id,
  eleIndex,
  elekey,
  disable,
  editingInput,
  showDelete,
  deleteItem,
  onChange,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };

  return (
    <FormGroup className="flex-fill position-relative">
      <div onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
        <label className={`asterisk-req f-14 ${fromForm && 'd-flex'}`}>
          {label}
          {requiredField && <span>*</span>}
        </label>
        <div className="align-items-center">
          {options?.map((opt, opIndex) => {
            return (
              <p className="custom-radio mb-0 mx-3" key={`_${eleIndex}_${opIndex}_${index}`}>
                <input
                  key={`_${eleIndex}_${opIndex}_${index}`}
                  type="radio"
                  id={`${opt?.name}_${opIndex}_${eleIndex}_${i}_${index}`}
                  name="radios"
                  value={opt?.name}
                  checked={opt?.value}
                  disabled={disable}
                  onChange={(e) => onChange(e.target.checked, opt?.name, i, eleIndex, index)}
                />
                <label className="m-0" htmlFor={`${opt?.name}_${opIndex}_${eleIndex}_${i}_${index}`}>
                  {opt?.name}
                </label>
              </p>
            );
          })}
          {fromForm && isOver && (
            <div className="potemp-action-btns">
              <button
                type="button"
                className="btn btn-border ml-auto  py-0 px-1"
                key={`_${eleIndex}_${i}_${index}_edit`}
                onClick={() => editingInput(index, i, eleIndex)}
              >
                <span className="icon-edit" />
              </button>
              {showDelete && isOver && (
                <button
                  type="button"
                  className="btn btn-border  py-0 px-1"
                  key={`_${eleIndex}_${i}_${index}_delete`}
                  onClick={() => deleteItem(index, i, elekey, eleIndex)}
                >
                  <span className="icon-delete" />
                </button>
              )}
              <button
                type="button"
                className="btn btn-border  py-0 px-1"
                key={`_${eleIndex}_${i}_${index}_copy`}
                onClick={() => (fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey))}
              >
                <span className="icon-copy" />
              </button>
            </div>
          )}
          {error?.status && <span className="error-message">{error.errorMsg}</span>}
        </div>
      </div>
    </FormGroup>
  );
}
export default Radio;
